<template>
    <div class="container" v-loading="true" style="height: 100%"></div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import AddRouterFunc from "@/router/addRouter";
    import routeData from '@/router/routerData'
    import { maiyuessoAuthorizeUrl } from "@/api/login";

    export default {
        name: "loginSso",
        props: [],
        components: {},
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                errorMsg: '',
                loginError: false,
            };
        },
        computed: {},
        created() {
            //清空缓存
            this.$store.commit("SET_ACCESS_TOKEN", null);
            this.$store.commit("SET_MENU", []);
            this.$store.commit("SET_PERMISSIONS", []);
            this.$store.commit("SET_CHOOSE_DEPT", []);
            // this.$store.commit("SET_ChOOSE_DATASCOPE_DEPT", []);
            this.$store.commit("SET_LOG_MSG", null);
            this.$store.commit("SET_ACTIVES", null);
            this.$store.commit("SET_ACTIVE_TAG", null);
            window.sessionStorage.setItem("nz_access_token", null);
            // sessionStorage.clear()
            // localStorage.clear();
            this.storageClear();
            if(this.$route.path == '/loginSsO'){
                let code = window.sessionStorage.getItem("loginSsoCode");
                if(code){
                    this.handleSubmitSSO(code)
                }else {
                    this.getUrl();
                }
            }
        },
        mounted() {},
        destroyed() {},
        methods: {
            ...mapActions(["setUserToken", "setUserData", "logout", "setAccessToken","bpmnSecurityLoginHandle"]),
            storageClear() {
                localStorage.removeItem("userData");
                localStorage.removeItem("token");
                sessionStorage.removeItem("vuex");
                sessionStorage.removeItem("nz_access_token");
                sessionStorage.removeItem("setConfig");
                sessionStorage.removeItem("userData");
            },
            // SSO登录的时候
            handleSubmitSSO(code) {
                this.$store
                    .dispatch("LoginByUsernameSSO",code)
                    .then(res => {
                        if ("access_token" in res.data) {
                            // await this.bpmLogin(res.data.username)
                            window.sessionStorage.setItem(
                                "nz_access_token",
                                "Bearer " + res.data.access_token
                            );
                            // 获取组织部门树
                            this.$store.dispatch("getDeptTree").then(() => {
                            }).catch((err) => {
                                console.log(err)
                            });
                            this.bpmnSecurityLoginHandle({
                                userName:res.data.username,
                                deviceType:'pc'
                            }).catch(() => {
                                // this.$store.commit("SET_ACCESS_TOKEN", null);
                                // sessionStorage.removeItem('nz_access_token')
                            });
                            //获取用户权限
                            this.$store.dispatch("GetUserPermissions").then((res) => {
                                //获取个人菜单;
                                let userInfo = {
                                    deviceType: 'pc',
                                    userId: res.data.sysUser.userId,
                                    userImg: res.data.sysUser.avatar,
                                    userName: res.data.sysUser.username,
                                    deptId: res.data.sysUser.deptId,
                                    roleCodes: res.data.roleCodes,
                                };
                                let routerData = res.data.permissions
                                routerData = [
                                    ...routerData,
                                    '/office',
                                    '/test',
                                    '/statistical/all',
                                    '/ServeCenterDetail',
                                    '/notifyDetail',
                                    '/search',
                                    '/noticesAndFilesPagination',
                                    '/fileDetail'
                                ]
                                if((res.data.roleCodes||[]).includes('ROLE_ADMIN')){
                                    routerData = [];
                                    const routeHandler = function (arr) {
                                        for(let i=0;i<arr.length;i++){
                                            routerData.push(arr[i].path)
                                            if(arr[i].children){
                                                routeHandler(arr[i].children)
                                            }
                                        }
                                    }
                                    routeHandler(routeData)
                                    routerData = routerData.concat([
                                        "system-management",
                                        "business-management",
                                        "advices-management",
                                        "efficiency-management",
                                        "data-management",
                                    ])
                                }

                                this.setUserData({
                                    ...userInfo,
                                    routerData,
                                });

                                localStorage.setItem('userData', JSON.stringify({
                                    ...userInfo,
                                    routerData,
                                }))

                                // sessionStorage.setItem('loginFrom', 'system')
                                sessionStorage.setItem('loginFrom', 'cassso')

                                this.logining = false

                                const routers = AddRouterFunc.getNewRouerData(
                                    routerData
                                );
                                this.$router.addRoutes(routers);

                                this.$router.push('/');

                            }).catch((err) => {
                                console.log(err)
                            })
                        } else {
                            this.logining = false;
                        }
                    })
            },
            //获取参数
            getUrlStr(name) {
                var url = document.location.toString();
                var arrObj = url.split("?");
                if (arrObj.length > 1) {
                    var arrPara = arrObj[1].split("&");
                    var arr;
                    for (var i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");
                        if (arr != null && arr[0] == name) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },
            goBack(){
                // this.$router.push("/login");
                // sso.ajaxLogout()
                sso.then((res) => {
                    res.ajaxLogout()
                })
            },
            bpmLogin(username){
                return new Promise((resolve, reject) => {
                    this.bpmnSecurityLoginHandle({
                        userName:username,
                        deviceType:'pc'
                    }).then(()=>{
                        resolve()
                    }).catch(() => {
                        this.$message.error('流程引擎登录失败')
                        this.$store.commit("SET_ACCESS_TOKEN", null);
                        sessionStorage.removeItem('nz_access_token')
                        reject()
                    })
                })
            },
            login(ticket){
                ssoLogin(ticket).then(async res => {
                    if ("access_token" in res.data) {
                        // await this.bpmLogin(res.data.username)

                        this.$store.commit('SET_ACCESS_TOKEN', res.data.access_token);
                        localStorage.token = res.data.access_token;
                        this.$store.commit('SET_LOG_MSG', res.data);

                        window.sessionStorage.setItem(
                            "nz_access_token",
                            "Bearer " + res.data.access_token
                        );
                        // 获取组织部门树
                        this.$store.dispatch("getDeptTree").then(() => {
                        }).catch((err) => {
                        });
                        this.bpmnSecurityLoginHandle({
                            userName:res.data.username,
                            deviceType:'pc'
                        }).catch(() => {
                            this.$message.error('流程引擎登录失败')
                            // this.$store.commit("SET_ACCESS_TOKEN", null);
                            // sessionStorage.removeItem('nz_access_token')
                        });
                        //获取用户权限
                        this.$store.dispatch("GetUserPermissions").then((res) => {
                            //获取个人菜单;
                            let userInfo = {
                                deviceType: 'pc',
                                // ip: '',
                                // routeJur: {},
                                userId: res.data.sysUser.userId,
                                userImg: res.data.sysUser.avatar,
                                userName: res.data.sysUser.username,
                                deptId: res.data.sysUser.deptId,
                                roleCodes: res.data.roleCodes,
                            };
                            let routerData = res.data.permissions
                            routerData = [
                                ...routerData,
                                '/office',
                                '/test',
                                '/statistical/all',
                                '/ServeCenterDetail',
                                '/notifyDetail',
                                '/serveEvaluate',
                                '/search',
                                '/noticesAndFilesPagination',
                                '/fileDetail',
                                '/teacherTimetable',
                                '/staff',
                                '/jobshire',
                                '/annualappraisal',
                                '/wage',
                                '/classroomQuery',
                                '/grade'
                            ]
                            if((res.data.roleCodes||[]).includes('ROLE_ADMIN')){
                                routerData = [];
                                const routeHandler = function (arr) {
                                    for(let i=0;i<arr.length;i++){
                                        routerData.push(arr[i].path)
                                        if(arr[i].children){
                                            routeHandler(arr[i].children)
                                        }
                                    }
                                }
                                routeHandler(routeData)
                                routerData = routerData.concat([
                                    "system-management",
                                    "business-management",
                                    "advices-management",
                                    "efficiency-management",
                                    "data-management",
                                ])
                            }
                            // routerData = ["/test","/accrualBasis","/serveEvaluate","/serveCenter","/addAdvice","/office","/mine","/management","/statistical","/statistical/all","/mine/userData","/mine/passwordEdit","/mine/message","/mine/collect","/mine/myAffair","/management/serve","/management/app","/management/theme","/management/user","/management/depManage","/management/tool","/management/flow","/management/complain","/management/search","/management/desktop","/management/homeCard","/management/file", "/management/QAHelper","/management/roleManage", '/management/special','/management/rightsli',"/management/reportManage","/management/policyFile","/mine/suggest","/mine/voiceMessage","/management/score","/management/navlink","/ServeCenterDetail","/management/advices","/management/showcase","/management/job","/management/label","/management/notification","/notifyDetail","/QAHelper", "/search","/noticesAndFilesPagination","/fileDetail",]  //暂时写死

                            this.setUserData({
                                ...userInfo,
                                routerData,
                            });

                            localStorage.setItem('userData', JSON.stringify({
                                ...userInfo,
                                routerData,
                            }))

                            sessionStorage.setItem('loginFrom', 'cassso')

                            this.logining = false

                            const routers = AddRouterFunc.getNewRouerData(
                                routerData
                            );
                            this.$router.addRoutes(routers);

                            this.$router.push('/office');

                        })
                    } else {
                        this.$message.error(res.data.msg || '登录出错')
                        this.errorMsg = res.data.msg || ''
                        this.loginError = true;
                    }
                }).catch((err) => {
                    this.$message.error(err || '登录出错')
                    this.loginError = true;
                })

            },
            //没有code 获取地址
            getUrl() {
            maiyuessoAuthorizeUrl().then(res => {
                if (res.data.success) {
                window.open(res.data.data, "_self");
                }
            });
            },
        },
        watch: {},
        filters: {},
    };
</script>

<style scoped lang="less">

</style>
